import { API_ROUTES } from "../utils/constants"
import apiHelper from "./apiHelper"

export function sendGlobalMassage(msg) {
    return apiHelper({ method: "post", path: API_ROUTES.SETTINGS.GLOBAL_MESSAGE.SEND, data: { msg } })
}

export function createSnapshot(serverId) {
    return apiHelper({ method: "post", path: API_ROUTES.SERVER.SNAPSHOT.CREATE, data: { serverId } })
}

export function deploySnapshot(serverId, snapshotName) {
    return apiHelper({ method: "post", path: API_ROUTES.SERVER.SNAPSHOT.DEPLOY, data: { serverId, snapshotName } })
}

export function deleteSnapshot(serverId, snapshotName) {
    return apiHelper({ method: "delete", path: API_ROUTES.SERVER.SNAPSHOT.DELETE, data: { serverId, snapshotName } })
}

export function getBackupList(serverId) {
    return apiHelper({ method: "post", path: API_ROUTES.SERVER.SNAPSHOT.GET_ALL, data: { serverId } })
}

export function downloadSnapshot(serverId, snapshotName) {
    return apiHelper({
        method: "get",
        path: `${API_ROUTES.SERVER.SNAPSHOT.DOWNLOAD}?serverId=${serverId}&backupName=${snapshotName}`,
    })
}
